export default __webpack_public_path__ + "static/media/home-seo-agency-img-01.ef864941.png";